// @flow

import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { isNilOrEmpty } from 'ramda-adjunct'

import { getCatchupMediaStreams } from '@alphaott/app-catchup/selectors'

export const useCatchupMediaStreams = (programId: string) => {
  const mediaStreams = useSelector(getCatchupMediaStreams(programId))

  const cachedMediaStreams = useMemo(() => mediaStreams, [programId]) // eslint-disable-line react-hooks/exhaustive-deps

  return useMemo(
    () => (isNilOrEmpty(cachedMediaStreams) ? mediaStreams : cachedMediaStreams),
    [cachedMediaStreams, mediaStreams],
  )
}

export default useCatchupMediaStreams
